export default "__VITE_ASSET__CRUX1Gsl__"